import { CorrelationBibTex, CorrelationApaReference } from "gatsby-theme-rpsych-correlation/src/components/content/Reference";
import * as React from 'react';
export default {
  CorrelationBibTex,
  CorrelationApaReference,
  React
};